export class SignUpAsCompanyForm {
  public constructor(
    public readonly username: string,
    public readonly email: string,
    public readonly password: string,
    public readonly companyName: string,
    public readonly nip: string,
    public readonly regulations: boolean,
    public readonly newsletter: boolean,
  ) {}
}
